import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL } from "@config/config";

const fetchSeasonalRoutes = async () => {
    const res = await axios.get(`${API_BASE_URL}/seasonal-voucher-manager`);
    return res.data?.data?.seasonalRoutes ?? null;
};

export const useSeasonalRoutes = () => {
    const { data } = useQuery({
        queryKey: ["seasonalRoutes"],
        queryFn: fetchSeasonalRoutes,
        staleTime: Infinity,
    });

    return {
        seasonalRoutes: data ?? null,
    };
};
